/**
 * @deprecated This is about to be replaced by text-based enum
 */
export const mediaFileType = {
  unspecified: 0,
  image: 1,
  audio: 2,
  video: 3,
  document: 4,
}
